import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IIntensityState {
  evaluationLoading: boolean;
}

export const initialState: IIntensityState = {
  evaluationLoading: false,
};

export const statePropName = 'trainingintensity';

const trainingIntensitySlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    trainingIntensitySelected: (state, action: PayloadAction<number>) => {
      state.evaluationLoading = true;
    },
    intensitySaveFailed: (state) => {
      state.evaluationLoading = false;
    },
    evaluationLoaded: (state) => {
      state.evaluationLoading = false;
    },
  },
});

export const TrainingIntensityActions = trainingIntensitySlice.actions;
export default trainingIntensitySlice.reducer;
